import React from "react";
import {Marker} from "@react-google-maps/api";
const Pin = ({ setSelected, mark, index, clusterer}) => {
    return (
        <Marker
            key={index}
            position={{lat:parseFloat(mark.lat),lng:parseFloat(mark.lan)}}
            clusterer={clusterer}

            onClick={() => setSelected(mark)}
        />
    )
};

export default Pin;